/**
 * Contact Form — inline validation, character counter, conditional order# field,
 * file label preview, honeypot guard, double-submit prevention.
 */
(function () {
  'use strict';

  var form = document.querySelector('[data-contact-form]');
  if (!form) return;

  /* ── Honeypot guard ── */
  var honey = form.querySelector('input[name="contact[website]"]');

  /* ── Conditional Order # field (subject-driven) ── */
  var subject = form.querySelector('[data-contact-subject]');
  var orderField = form.querySelector('[data-contact-order-field]');

  if (subject && orderField) {
    var toggleOrder = function () {
      var opt = subject.options[subject.selectedIndex];
      var shows = opt && opt.getAttribute('data-shows-order') === 'true';
      orderField.classList.toggle('hidden', !shows);
    };
    subject.addEventListener('change', toggleOrder);
    toggleOrder();
  }

  /* ── Character counter on message ── */
  var msg = form.querySelector('[data-contact-message]');
  var counter = form.querySelector('[data-contact-counter]');
  if (msg && counter) {
    var max = parseInt(msg.getAttribute('maxlength'), 10) || 1500;
    var update = function () {
      var len = msg.value.length;
      counter.textContent = len + ' / ' + max;
      counter.classList.toggle('text-brand-error', len >= max - 50 && len < max);
      counter.classList.toggle('text-brand-accent-text', len >= max);
    };
    msg.addEventListener('input', update);
    update();
  }

  /* ── File-input label preview ── */
  var fileInput = form.querySelector('[data-contact-file]');
  var fileLabel = form.querySelector('[data-contact-file-label]');
  if (fileInput && fileLabel) {
    var defaultLabel = fileLabel.textContent;
    fileInput.addEventListener('change', function () {
      var f = fileInput.files && fileInput.files[0];
      if (!f) {
        fileLabel.textContent = defaultLabel;
        return;
      }
      if (f.size > 4 * 1024 * 1024) {
        fileLabel.textContent = 'File too large (max 4MB)';
        fileLabel.classList.add('text-brand-error');
        fileInput.value = '';
        return;
      }
      fileLabel.classList.remove('text-brand-error');
      fileLabel.textContent = f.name + ' (' + (f.size / 1024 / 1024).toFixed(2) + ' MB)';
    });
  }

  /* ── Inline validation helpers ── */
  function setError(input, message) {
    input.classList.add('contact-input--error');
    input.setAttribute('aria-invalid', 'true');
    var err = input.parentNode.querySelector('[data-contact-error]');
    if (err) {
      err.textContent = message;
      err.classList.remove('hidden');
    }
  }
  function clearError(input) {
    input.classList.remove('contact-input--error');
    input.removeAttribute('aria-invalid');
    var err = input.parentNode.querySelector('[data-contact-error]');
    if (err) {
      err.textContent = '';
      err.classList.add('hidden');
    }
  }

  /* Re-validate on blur (after first interaction) */
  form.querySelectorAll('[data-contact-required]').forEach(function (input) {
    input.addEventListener('blur', function () {
      validateField(input);
    });
    input.addEventListener('input', function () {
      if (input.classList.contains('contact-input--error')) validateField(input);
    });
  });

  function validateField(input) {
    var value = input.value.trim();
    if (!value) {
      setError(input, 'This field is required');
      return false;
    }
    if (input.hasAttribute('data-contact-email') && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setError(input, 'Please enter a valid email');
      return false;
    }
    if (input.hasAttribute('data-contact-message') && value.length < 10) {
      setError(input, 'Please add a bit more detail (min 10 characters)');
      return false;
    }
    clearError(input);
    return true;
  }

  /* ── Submit handler ── */
  var submitBtn = form.querySelector('button[type="submit"]');
  var submitLabel = form.querySelector('[data-contact-submit-label]');
  var originalLabel = submitLabel ? submitLabel.textContent : '';

  form.addEventListener('submit', function (e) {
    /* Honeypot — silently block bots */
    if (honey && honey.value) {
      e.preventDefault();
      return;
    }

    /* Validate all required fields */
    var allValid = true;
    form.querySelectorAll('[data-contact-required]').forEach(function (input) {
      if (!validateField(input)) allValid = false;
    });

    if (!allValid) {
      e.preventDefault();
      var firstError = form.querySelector('.contact-input--error');
      if (firstError) firstError.focus();
      return;
    }

    /* Disable submit + change label to prevent double-submit */
    if (submitBtn) {
      submitBtn.setAttribute('disabled', 'disabled');
      submitBtn.classList.add('opacity-70', 'cursor-wait');
    }
    if (submitLabel) submitLabel.textContent = 'Sending…';
  });
})();
